module.exports = __webpack_public_path__ + "static/media/smiley_face_no_shadow.cf8c5a16.svg";